import { Tutorial } from '@components/tutorial/Tutorial';
import { useGameStore, useAppStore } from '@stores';
import { useTranslation } from 'react-i18next';
import { Step } from 'react-joyride';

export function CombatTutorial() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial.Combat' });
  const { isConnecting } = useAppStore();
  const { isLoading } = useGameStore();

  if (isLoading || isConnecting) return null;

  const steps: Step[] = [
    {
      target: '.ps-container',
      placement: 'center',
      content: t('combat0'),
    },
    {
      target: '.ps-container',
      placement: 'top',
      content: t('combat1'),
    },
    {
      target: '.ability-bar',
      placement: 'top',
      content: t('combat2'),
    },
    {
      target: '.ability-bar',
      placement: 'center',
      content: <>
        <p>{t('combat3_1')}</p>
        <p className="my-2 text-gold">{t('combat3_2')}</p>
        <p>{t('combat3_3')}</p>
      </>
    },
  ];

  return <Tutorial tutorialKey="Combat" steps={steps} />;
}